'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _class2, _temp2, _class3, _temp3;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _veInlineTip = require('@ali/ve-inline-tip');

var _veInlineTip2 = _interopRequireDefault(_veInlineTip);

var _index = require('./svglib/index');

var _index2 = _interopRequireDefault(_index);

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var IconsList = Object.keys(_index2.default).map(function (name) {
  return {
    name: name,
    icon: _index2.default[name]
  };
});
var IconsDict = { default: _index2.default };

function testType(src) {
  var t = typeof src === 'undefined' ? 'undefined' : _typeof(src);
  if (t === 'function' && src.prototype && (src.prototype.isReactComponent || src.prototype instanceof _react2.default.Component)) {
    return 'ReactClass';
  } else if (t === 'object' && _react2.default.isValidElement(src)) {
    return 'ReactElement';
  }
  return t;
}

function hasIcon(name) {
  var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

  return IconsDict[namespace] && IconsDict[namespace][name];
}

var RE_NAME = /^(\w+)\.(.+)$/;
function getIcon(name) {
  var m = RE_NAME.exec(name);
  var namespace = 'default';
  if (m) {
    namespace = m[1];
    name = m[2];
  }
  if (hasIcon(name, namespace)) {
    return IconsDict[namespace][name];
  }
  return null;
}

function getList() {
  return IconsList;
}

function registerDict(namespace, dict) {
  IconsDict[namespace] = dict;
}

var Icons = (_temp = _class = function (_React$Component) {
  _inherits(Icons, _React$Component);

  function Icons() {
    _classCallCheck(this, Icons);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Icons.prototype.render = function render() {
    var _props = this.props,
        name = _props.name,
        effect = _props.effect,
        props = _objectWithoutProperties(_props, ['name', 'effect']);

    var type = testType(name);

    props.className = (0, _classnames2.default)('ve-svgicon', _defineProperty({}, 've-icon-effect-' + effect, effect), props.className);

    if (type === 'ReactClass') {
      return _react2.default.createElement(name, props);
    }
    if (type === 'ReactElement') {
      return _react2.default.cloneElement(name, props);
    }

    var Icon = getIcon(name);
    if (type === 'string' && Icon) {
      return _react2.default.createElement(Icon, props);
    }
    return null;
  };

  return Icons;
}(_react2.default.Component), _class.defaultProps = {
  size: 'large',
  name: 'success'
}, _class.propTypes = {
  name: _react2.default.PropTypes.any,
  effect: _react2.default.PropTypes.string
}, _temp);


Icons.getIcon = getIcon;

Icons.getList = getList;

Icons.registerDict = registerDict;

var Button = (_temp2 = _class2 = function (_React$Component2) {
  _inherits(Button, _React$Component2);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Button.prototype.render = function render() {
    var _props2 = this.props,
        size = _props2.size,
        text = _props2.text,
        children = _props2.children,
        name = _props2.name,
        theme = _props2.theme,
        effect = _props2.effect,
        props = _objectWithoutProperties(_props2, ['size', 'text', 'children', 'name', 'theme', 'effect']);

    var className = (0, _classnames2.default)('ve-icon-button', 've-icon-button-' + this.props.theme, props.className);
    var contents = text || children;

    return _react2.default.createElement(
      'div',
      _extends({}, props, { className: className }),
      _react2.default.createElement(Icons, { name: name, size: size || 'small', effect: effect }),
      contents && _react2.default.createElement(
        'span',
        { className: 've-icon-contents' },
        contents
      )
    );
  };

  return Button;
}(_react2.default.Component), _class2.propTypes = {
  className: _react2.default.PropTypes.string,
  theme: _react2.default.PropTypes.string,
  text: _react2.default.PropTypes.node,
  children: _react2.default.PropTypes.node,
  size: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
  name: _react2.default.PropTypes.any,
  effect: _react2.default.PropTypes.string
}, _class2.defaultProps = {
  size: 'small',
  theme: 'default'
}, _temp2);


Icons.Button = Button;

var Tip = (_temp3 = _class3 = function (_React$Component3) {
  _inherits(Tip, _React$Component3);

  function Tip() {
    _classCallCheck(this, Tip);

    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
  }

  Tip.prototype.render = function render() {
    var _props3 = this.props,
        size = _props3.size,
        name = _props3.name,
        url = _props3.url,
        position = _props3.position,
        children = _props3.children,
        props = _objectWithoutProperties(_props3, ['size', 'name', 'url', 'position', 'children']);

    props.className = (0, _classnames2.default)('ve-icon-tip', props.className);

    if (url) {
      return _react2.default.createElement(
        'a',
        _extends({
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, props, {
          target: '_blank',
          rel: 'noopener noreferrer',
          href: url
        }),
        _react2.default.createElement(Icons, { name: name || 'doubt', size: size || 'small' }),
        _react2.default.createElement(
          _veInlineTip2.default,
          { position: position },
          children
        )
      );
    }

    return _react2.default.createElement(
      'i',
      props,
      _react2.default.createElement(Icons, { name: name || 'doubt', size: size || 'small' }),
      _react2.default.createElement(
        _veInlineTip2.default,
        { position: position },
        children
      )
    );
  };

  return Tip;
}(_react2.default.Component), _class3.propTypes = {
  className: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.node,
  size: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
  name: _react2.default.PropTypes.any,
  url: _react2.default.PropTypes.string,
  position: _react2.default.PropTypes.string
}, _class3.defaultProps = {
  size: 'small'
}, _temp3);


Icons.Tip = Tip;

module.exports = Icons;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/index.js
// module id = 133
// module chunks = 0